import React from "react";
import { Input, Row } from "reactstrap";
import { ColPrompt } from "./index";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";
// Used on the following machines: Leesona FC/Tackified/Wax machines,
// DP5, DS10-E, SSM Duro, M50, M50 Wax, Mahan Oven, Sahm 230E,
// SSM Kingspool, Texilmesa Kingspool, and SSM Xeno.

export default function MinMaxRow({
   titleProp,
   minProp1,
   maxProp1,
   minProp2,
   maxProp2,
   errorProp1,
   errorProp2,
   descriptionProp = "",
   valueProp1,
   valueProp2,
   floatProp1,
   floatProp2,
   differentDisplayProp1,
   differentDisplayProp2,
}) {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };

   return (
      <Row className="mb-2">
         <ColPrompt title={titleProp} bold={true} description={descriptionProp} />
         <ColValue size={2}>
            {differentDisplayProp1 ? differentDisplayProp1 : "Min:"}
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[valueProp1] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, minProp1, maxProp1, valueProp1, false, floatProp1)
                     : handleInputRangeChange(defaultOnChangeVal, minProp1, maxProp1, valueProp1)
               }
            />
            {errorDivDefinitions?.[valueProp1] && <ErrorDiv>{errorProp1}</ErrorDiv>}
         </ColValue>
         <ColValue size={2}>
            {differentDisplayProp2 ? differentDisplayProp2 : "Max:"}
            <Input
               type="text"
               style={{ borderRadius: "10px", fontSize: "14px" }}
               value={machineSetup.extendedPropertyJson?.[valueProp2] || ""}
               onChange={(e) =>
                  e.target.value
                     ? handleInputRangeChange(e, minProp2, maxProp2, valueProp2, false, floatProp2)
                     : handleInputRangeChange(defaultOnChangeVal, minProp2, maxProp2, valueProp2)
               }
            />
            {errorDivDefinitions?.[valueProp2] && <ErrorDiv>{errorProp2}</ErrorDiv>}
         </ColValue>
      </Row>
   );
}
